module.exports = __webpack_public_path__ + "static/img/gaozhongdili5.6b73f32d.jpg";